<!-- added by Samikchha Kumar on 25-Mar-2023 -->
<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top: 10px;">
      <div class="panel panel-default" id="panel4" style="margin-bottom: 0px !important;">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Export Employees Records</b>
            </a>
          </h4>
        </div>
      </div>
      <!-- Buttons -->
     <div class="row" id="divTop" style="margin-bottom: 10px;">
       <div class="col-md-9 col-lg-9 col-sm-9">
            <div id="ButtonsTab">

               <button id="btnReset" type="button" title="Reset" class="btn btn-primary" (click)="ResetResult();">
                <span style="width: 85px;">Reset</span>
              </button>
              <button id="btnExport" type="button" title="Export" (click)="ExportToExcel();" class="btn btn-primary">
                <span class="hidden-xs" style="width: 85px;">Export</span><i class="fa fa-close hidden-lg hidden-md"></i>
              </button>
              <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit();">
                <span class="hidden-xs" style="width: 85px;">Exit</span><i class="fa fa-close hidden-lg hidden-md"></i>
              </button>
            </div>
          </div>
          <div class="col-md-3 col-xs-3" style="padding-right: 0px;">
            <div style="text-align: right;padding-right:5px;margin-top:20px;">
              <h6 style="color: #808080; font-size: 13px; font-style: oblique; font-weight:bold;"></h6>
            </div>
          </div>
        </div>
      
      <!-- Buttons -->
      <div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">
              The
              following errors were encountered on the page.
            </span>
          </div>
          <div id="divMainError" class="text-error"
               style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
      <!-- Search Criteria -->
      <div class="panel panel-default" id="panel4">
        <div class="panel-heading panel-heading1">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Search Criteria &nbsp;&nbsp; (Click (+/-) to view the Search Parameters)</b>
              <b class="pull-right collapsed"></b>
            </a>
          </h4>
        </div>
        <div>
         
          <div class="panel-body">
  <div class="row" style="margin: 10px;">
            <div class="col-md-6">
              <div class="form-group">
                <span class="col-sm-4">Reviewed on from date</span>
                <div class="col-md-8 col-sm-8">
                  <!--Added  by Shreya CR_2303_0039-->
                  <div class="input-group date">
                    <input matInput class ="form-control" style="width: 250px;" [matDatepicker]="FromDate"
                                          (dateChange)="ChangeDateFormat($event,'FromDate')"
                                          [(ngModel)]="FTERecordsList.FromDate"
                                           placeholder="Choose a date">
                      <mat-datepicker-toggle matSuffix [for] ="FromDate">
                        </mat-datepicker-toggle>
                        <mat-datepicker #FromDate>
                          </mat-datepicker>
                          <!-- {{FTERecord.LastIncrementDate | date:"dd-MMM-yyyy"}} -->
                          <!--Added  by Shreya CR_2303_0039-->
                  </div>
                </div>
              </div>
            </div>
           
              <div class="col-md-6">
                <div class="form-group">
                  <span class="col-sm-4">Reviewed on to date</span>
                  <div class="col-md-8 col-sm-8">
                    <!--Added  by Shreya CR_2303_0039-->
                    <div class="input-group date">
                      <input matInput class ="form-control" style="width: 250px;" [matDatepicker]="ToDate"
                                            (dateChange)="ChangeDateFormat($event,'ToDate')"
                                            [(ngModel)]="FTERecordsList.ToDate"
                                             placeholder="Choose a date">
                        <mat-datepicker-toggle matSuffix [for] ="ToDate">
                          </mat-datepicker-toggle>
                          <mat-datepicker #ToDate>
                            </mat-datepicker>
                            <!-- {{FTERecord.LastIncrementDate | date:"dd-MMM-yyyy"}} -->
                            <!--Added  by Shreya CR_2303_0039-->
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!-- End by Samikchha on 29 May 2024 -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

